import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';

import useLabel from '../../../../context/Label/useLabel';
import styles from './FillInTheBlanks.module.scss';
import Sentence from './Sentence';

type FillInTheBlanksProps = {
  question: any;
  tracking: any;
  config: any;
  onChange: (arg1: any, arg2: { value: string; questionId: string }) => void;
};

function FillInTheBlanks(props: FillInTheBlanksProps) {
  const { question, tracking, config, onChange } = props;
  const { showCorrectAnswer, showYourAnswers } = config;
  const { answer, submitted } = tracking;
  const { register, watch, getValues } = useForm({ defaultValues: answer });
  const { plainLabel } = useLabel();
  const typeHere = useMemo(() => plainLabel('type here'), [plainLabel]);

  // this is HOW you detect changes using react-hook-form
  useEffect(() => {
    const subscription = watch((value, { name, type }) => {
      onChange &&
        onChange(undefined, {
          value,
          questionId: question.resourceId,
        });
    });
    return () => subscription.unsubscribe();
  }, [watch]); // eslint-disable-line

  return (
    <div className={styles.FillInTheBlanks}>
      <Sentence
        sentence={question?.sentence}
        blanks={question?.blanks}
        submitted={submitted}
        showYourAnswers={showYourAnswers}
        showCorrectAnswer={showCorrectAnswer}
        getValues={getValues}
        register={register}
        placeholder={typeHere}
      />
    </div>
  );
}

export default FillInTheBlanks;
